import { render } from "./ListModule.vue?vue&type=template&id=dd742e28"
import script from "./ListModule.vue?vue&type=script&lang=js"
export * from "./ListModule.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__